"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-one/sections/companySection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import Slider from "react-slick";
import { FC, ComponentProps, Key, ReactNode } from "react";

type CompanySectionSlidesItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/company/company-01.svg" | "/Templates/Doccure/img/company/company-02.svg" | "/Templates/Doccure/img/company/company-03.svg" | "/Templates/Doccure/img/company/company-04.svg" | "/Templates/Doccure/img/company/company-05.svg" | "/Templates/Doccure/img/company/company-06.svg" | "/Templates/Doccure/img/company/company-07.svg" */
    src: string;
    /** Detected variants: "slide-item" */
    className?: string;
    /** Detected variants: "img" */
    alt?: string;
};
const settings = {
    dots: false,
    infinite: true,
    speed: 2000,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    responsive: [
        {
            breakpoint: 1400,
            settings: {
                slidesToShow: 6,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            },
        },
    ],
};

export type HomeOneCompanySectionGeneratedProps = {
    /** Default: "1s" */
    divDataWowDuration?: string;
    /** Default: "Trusted Partners with Doccure" */
    divDiv0Div0P0PText?: ReactNode;
    divDiv0Slider0SliderProps?: Partial<ComponentProps<typeof Slider>>;
    divImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: CompanySectionSlidesItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    companySectionSlides: CompanySectionSlidesItem[];
    companySectionSlidesItemWrapper?: (item: CompanySectionSlidesItem, content: ReactNode) => ReactNode;
    companySectionSlidesRenderer?: (defaultNode: ReactNode) => ReactNode;
    companySectionSlidesImageVisible?: boolean;
    companySectionSlidesImageRenderer?: (item: CompanySectionSlidesItem, defaultNode: ReactNode) => ReactNode;
    companySectionSlidesImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: CompanySectionSlidesItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
};

const HomeOneCompanySectionGenerated: FC<HomeOneCompanySectionGeneratedProps> = ({
    divDataWowDuration = "1s",
    divDiv0Div0P0PText = "Trusted Partners with Doccure",
    divDiv0Slider0SliderProps,
    divImageWithBasePath0ImageProps,
    companySectionSlides,
    companySectionSlidesItemWrapper,
    companySectionSlidesRenderer,
    companySectionSlidesImageVisible,
    companySectionSlidesImageRenderer,
    companySectionSlidesImageProps,
}) => {
    return (
        <div className="company-section section bg-dark wow fadeOut" data-wow-duration={divDataWowDuration}>
            <div className="container">
                <div className="section-header text-center">
                    <p className="text-light m-0 fw-semibold">{divDiv0Div0P0PText}</p>
                </div>
                <Slider {...settings} className="company-slider" {...(divDiv0Slider0SliderProps ?? {})}>
                    {renderCollectionNode(
                        companySectionSlides,
                        (item: CompanySectionSlidesItem) => (
                            <div className={item.className ?? "slide-item"} key={item.key}>
                                {renderItemNode(companySectionSlidesImageVisible, companySectionSlidesImageRenderer, item, (
                                    <SmartImage src={item.src} alt={item.alt ?? "img"} {...(typeof companySectionSlidesImageProps === "function" ? companySectionSlidesImageProps(item) : (companySectionSlidesImageProps ?? {}))} {...(typeof divImageWithBasePath0ImageProps === "function" ? divImageWithBasePath0ImageProps(item) : (divImageWithBasePath0ImageProps ?? {}))} />
                                ))}
                            </div>
                        ),
                        companySectionSlidesItemWrapper,
                        companySectionSlidesRenderer
                    )}
                </Slider>
            </div>
        </div>
    );
};

export default HomeOneCompanySectionGenerated;
